/**
 * @module PeriodSwitch
 */
class PeriodSwitch {

    constructor() {

        this._state = {
            monthly: true
        };

        this._initialize();

    }

    /**
     * Initialize the chart
     *
     * @private
     */

    _initialize() {
        this._cacheSelectors();
        this._setupMutationObserver();
        this._handlePeriods();
    }

    /**
     * Cache selectors
     *
     * @private
     */
    _cacheSelectors() {
        this._periods = [...document.querySelectorAll('[data-period="month"],[data-period="year"]')];
        this._body = document.body;
    }

    /**
     * Set aria-hidden attribute per period element
     *
     * @private
     */
    _handlePeriods() {
        this._periods.forEach(period => {
            const isMonthly = period.getAttribute('data-period') === 'month';
            const isHidden = this._state.monthly ? !isMonthly : isMonthly;
            period.setAttribute('aria-hidden', isHidden);
        });
    }


    /**
     * Setup mutation observer for the monthly/yearly price
     * @private
     */
    _setupMutationObserver() {
        const callback = mutationsList => {
            mutationsList.forEach(mutation => {
                const isMonthlyAttributeChanged =
                    mutation.type === 'attributes' &&
                    mutation.attributeName === 'data-monthly';
                if (isMonthlyAttributeChanged) {
                    this._state.monthly =
                        this._body.getAttribute('data-monthly') === 'true';
                    this._handlePeriods();
                }
            });
        };

        const _observer = new MutationObserver(callback);
        _observer.observe(this._body, { attributes: true });
    }
}

export default PeriodSwitch;
